import React from "react";
import { Tooltip } from "reactstrap";
import '../assets/custom.css'

class CratioTooltip extends React.Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            tooltipOpen: false,
        };
    }

    toggle() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen,
        });
    }

    render() {

        let {title, content, id, placement} = this.props;
        let { tooltipOpen } = this.state;

        let tooltipid = (id === undefined) ? 0 : id;
        let tooltipPlacement = (placement === undefined) ? 'top' : placement;

        return (
            <span>
                <span className="cratio-tooltip-div" color="primary" id={"Tooltip-content-"+tooltipid}>
                    {content}
                </span>
                {
                    title !== "" &&
                    <Tooltip
                        placement={tooltipPlacement}
                        isOpen={tooltipOpen}
                        target={"Tooltip-content-"+tooltipid}
                        toggle={this.toggle}
                        className={'cratio-tooltip'}
                    >
                        { title }
                    </Tooltip>
                }
            </span>
        );
    }
}

export default CratioTooltip;
